<template>
	<v-container fluid>
		<v-row
			dense
		>
			<!-- search -->
			<v-col
				cols = "12"
				
			>
				<v-card outlined>
					
					<v-card-title
						class = "secondary pa-0  px-2 body-1 black--text"
					>	
						<v-icon 
							small 
							color  = "blue"
							class  = "mx-1"
							@click = "$router.back()"
						>
							mdi-play-box-multiple
						</v-icon>
						<strong
							class = "white--text"
						>
							
							{{ $ml.get('playback') }}
						</strong>
						
						<v-spacer></v-spacer>
						
						<v-icon 
							small 
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>mdi-arrow-left-circle</v-icon>
					</v-card-title>
					<v-card-text
						class = "pa-1"
					>
						
						<v-row>
							<template
								v-for = "(item_search, idx_search) of info_search_fields"
							>
								<v-col
									:key  = "idx_search"
									:cols = "item_search.cols.col"
								>
									<v-select
										v-if 		= "item_search.type == 'select'"
										dense
										outlined
										hide-details
										:items 	  	 = "render_listed(item_search.list)"
										:label         = "$ml.get(item_search.text)"
										v-model  	 = "info_search[item_search.key]"
										:item-value	 = "item_search.key_list"
										:item-text 	 = "item_search.text_list"
										:placeholder = "$ml.get(item_search.placeholder)"
										@input 		 = "get_list()"
									></v-select>

									
								</v-col>
							</template>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			
			
			<!-- list playback -->
			<v-col
				cols = "12"
				v-show 	= "show" 
			
			>
				<v-card 
					outlined

				>
					<v-card-text>
						<v-row>
							<v-col>

								<v-card 
									outlined
									height = "100%"
								>	
								<v-card-title
									class = "primary pa-0 body-2"
								>	
									<v-icon
										x-small
										color  = "white"
										class  = mx-2
										v-text = "'mdi-video'"
									></v-icon>
									{{ 'Video Evidence' }}
								</v-card-title>
									<v-card-text @click="next_video()">
									<video  
										width="100%" 
										height="88%" 
										 
										v-if = "url_video"
										autoplay="autoplay" loop="loop" controls="controls" tabindex="0"
										>
<!-- 										preload="auto"  -->
										<!-- @ended="start_Playback()" -->
										 <source 
										 :src="url_video"
										   type='video/mp4' />
									</video>
									</v-card-text>
								</v-card>

							</v-col>
							
						</v-row>			
					</v-card-text>
					<!-- <v-card-actions>
						
					</v-card-actions>	 -->
				</v-card>

			</v-col>

			<!-- play video -->
			<!-- <v-col
				cols 	= "12"
				v-show 	= "show" 
			>	
				
			</v-col> -->
		</v-row>
		
	</v-container>
</template>
<script>
	import { GChart } from 'vue-google-charts'

	export default{
		name 		: 'playback',
		components  : {
			GChart
		}, // components
		data : (vm) => ({
			info 				: {},
			info_search 		: {},
			info_search_fields 	: [
				{
					key 		: 'search',
					text 		: 'search',
					placeholder : 'device',
					list 		: 'list_devices',
					key_list	: 'deviceId',
					text_list 	: 'name',
					type 		: 'select',
					cols 		: {
						col : 4,
					},
				},
				{
					key 		: 'dates',
					text 		: 'date',
					placeholder : 'select',
					type 		: 'date',
					cols 		: {
						col : 3,
					},
				},
				{
					key 		: 'start',
					menu 		: 'picker_start',
					ref 		: 'menu_start',
					text 		: 'Start',
					placeholder : 'time',
					type 		: 'time_picker',
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'end',
					menu 		: 'picker_end',
					ref 		: 'menu_end',
					text 		: 'End',
					placeholder : 'time',
					type 		: 'time_picker',
					cols 		: {
						col : 2,
					},
				}

			],
			list_devices 	: [],
			list_search 	: [],
			menu 		 	: false,
			dates 		 	: [], 	
			menu_picker 	: {
				start	: false, // menu
				end		: false,			
			},
			picker 			: {
				start	: "00:00", // 
				end		: "23:59",
			},

			show 		 	: true,
			ID_notification : 'playback',
			options 		: { itemsPerPage : 30 },
			total 			: 0,
			
	     	size_height		: 100,
			size_width 		: 100,
			videoTimeline:[],
			indexPLay:0,
			video:{
				urlpath:""
			},
			url_video : 'http://localhost:9090',
		}), // data  

		created(){
			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}
			console.log(this.$momentz(), this.$momentz().format('L'))
			// this.dates.push(this.formatDate(this.$momentz().format('L')));
			// this.get_list();
			console.log(this.formatDate(this.$momentz().format('L')), "DATE FORMAT")
			this.get_list()

		}, // created

		watch:{

			options: {
				handler(){
					// this.get_list();

				}, deep: true, 
			}, // optitons

		}, // watch

		methods : {

			actions(act, item, opt){
				switch (act){
					case ('set_dates') : {
						// this.dates = item;
						this.menu = false;
					}break;
					default : {
						console.log("this option not exist ")
					}
				};
			}, // actions
			
			render_listed (list){
				return this[list];

			}, // render listed




			next_video(){
				this.indexPLay++
				this.video 		= this.videoTimeline[this.indexPLay]
				this.url_video  = '';
				const timer = setTimeout(()=>{

					this.url_video  = this.video && this.video.urlpath ? 
									'http://'+this.$localhost+':' + this.$port+ this.video.urlpath : ''; 

					clearTimeout(timer)
				}, 100)
			},
			start_Playback(){
				this.indexPLay++
				this.video 		= this.videoTimeline[this.indexPLay]
				this.url_video  = this.video && this.video.urlpath ? 
								 'http://'+this.$localhost+':'+this.$port+ this.video.urlpath : '';
				
				
			},
			get_data_axios(api,info_up,page=0){
				let  vm = this;
				page++
				let newapi = api+"/?page="+page
				this.$axios.post(newapi, info_up).then( res => {
					vm.videoTimeline = vm.videoTimeline.concat(res.data.rows)
					console.log(page,parseInt(res.data.pages),page<parseInt(res.data.pages))
					if(page == 1){
						if (vm.videoTimeline && vm.videoTimeline.length > 0) {
							vm.video = vm.videoTimeline[0]
							vm.url_video  = '';
							const timer = setTimeout(()=>{
								vm.url_video = vm.video && vm.video.urlpath ? 
								 'http://'+vm.$localhost+':'+ vm.$port+ vm.video.urlpath : '';
								clearTimeout(timer);
							}, 100);
						}

					}
					if(page < parseInt(res.data.pages)){
						
						vm.get_data_axios(api,info_up,parseInt(page))
					}
					
					

		    		//console.log(" Get list ", this.ID_notification);
		    		//console.log(res);


		    	}).catch( er => {
		    		console.log(" Error Get list ", this.ID_notification + ' : ', er);
		    	});

			},

		    
		    get_list(){
				this.videoTimeline=[]
		    	let info_search = this.info_search;
		    	let info_up 	= null;
		    	if (info_search) {

		    		info_up = {
		    			start 	 	:  this.$momentz(this.$momentz.now()).format('L'), 
		    			end 	 	:  this.$momentz(this.$momentz.now()).format('L'),		    			
		    			deviceId :  info_search.search, 
		    		}

		    		
		    		
		    	}
		    	console.log("request : ******************** ", info_up);
		    	const api 	= this.$URL + '/api/v1/records/find';
		    	const api1 	= this.$URL + '/api/v1/object/find';
				this.get_data_axios(api,info_up,0)

		    }, // get list	

		   
		}, // methods
	};
</script>